import React, { useState, useEffect, useRef } from 'react'
import { toast, ToastContainer } from 'react-toastify';

import { getLogoSvc, getPrinciSignSvc, getTermReportSvc } from './termReportSvc';
import TermReportPdfAndroid from './pdf/termReportPDFAndroid';



const TermReportSliderAndroid = (props) => {
    const { sectionId, termId, term, syllabusId, setLoader, closeSlider } = props;

    const [opacity, setOpacity] = useState(1);
    const [termReportCard, setTermReportCard] = useState({});
    const [logoUrl, setLogoUrl] = useState('');
    const [principalSign, setPrincipalSign] = useState("");


    useEffect(() => {

        // console.log("termReportSlider called, term passed", term);
        getTermReport(termId, sectionId, syllabusId);
        getLogoSvc(cbLogoResponse);
        getPrinciSignSvc(cbPrinciSign);
    }, [termId, sectionId, syllabusId]);

    function cbLogoResponse(imageUrl) {
        // console.log("cbLogoResponse called, imageUrl", imageUrl);
        setLogoUrl(imageUrl)
    }

    function cbPrinciSign(imageUrl) {
        setPrincipalSign(imageUrl);
    }


    const getTermReport = (pTermId, pSectionId, pSyllabusId) => {
        setLoader("block");
        setOpacity(0.5);
        getTermReportSvc(pTermId, pSectionId, pSyllabusId, TermReportResponse);
    }

    const TermReportResponse = async (data) => {
        // console.log("TermReportResponse called, data", data);
        let obj = data;
        if (obj.status === 'Success') {
            setTermReportCard(obj.lstReportCardObj);
        } else {
            setTermReportCard({});
            if (obj.message === 'You are not logged in' || obj.message === 'Your Session is expired, login again') {
                setTimeout(() => {
                    window.location.href = "/";
                }, 2000);
                return false;
            } else {
                toast.error(obj.message);
            }
        }

        setLoader("none");
        setOpacity(1);
    };

    const closePdf = () => {
        setTermReportCard([]);
        closeSlider();
    }



    return (
        <TermReportPdfAndroid
            logoUrl={logoUrl}
            termReportCard={termReportCard}
            term={term}
            principalSign={principalSign}
            setLoader={setLoader}
            closePdf={closePdf}
        />
    );
}

export default TermReportSliderAndroid;